import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { event } from '@uhg-abyss/web/tools/event';
import { ModalDialog } from '@uhg-abyss/web/ui/ModalDialog';
import { Button } from '@uhg-abyss/web/ui/Button';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { storage } from '@uhg-abyss/web/tools/storage';
import { config } from '@uhg-abyss/web/tools/config';
import { Layout } from '@uhg-abyss/web/ui/Layout';

export const SubscribeModal = ({
  isSubscribeModalOpen,
  setIsSubscribeModalOpen,
}) => {
  const { navigate } = useRouter();
  const modalName =
    'meeting request with an api consultant before sign in modal';

  useEffect(() => {
    if (isSubscribeModalOpen) {
      event('MODAL_VIEW', {
        event,
        modalName,
      });
    }
  }, [isSubscribeModalOpen]);

  const cancelEvent = () => {
    event('MODAL_CLOSE', {
      event,
      modalName,
    });
  };
  const onModalClose = () => {
    cancelEvent();
    setIsSubscribeModalOpen(false);
  };
  const signIn = () => {
    const interactionName = `welcome`;
    const interactionValue = 'welcome';
    const interactionContext = '';
    event('INTERACTION_EVENT', {
      interactionName,
      interactionValue,
      interactionContext,
    });

    if (process.env.NODE_ENV === 'development') {
      navigate('/welcome');
    } else {
      window.location = `${config('IDENTITY_API_URL')}/login`;
    }

    storage.local.set('IS_SIGN_IN_CLICKED', true);
    if (storage.local.get('IS_SIGNED_OUT')) {
      storage.local.remove('IS_SIGNED_OUT');
    }

    setIsSubscribeModalOpen(false);
  };
  const footer = (
    <Layout.Group>
      <Button
        variant="outline"
        fontSize="15px"
        onClick={() => {
          setIsSubscribeModalOpen(false);
          cancelEvent();
        }}
      >
        Cancel
      </Button>
      {process.env.NODE_ENV === 'development' ? (
        <Button fontSize="15px" onClick={signIn}>
          Sign In/Up
        </Button>
      ) : (
        <Button
          href={`${config('IDENTITY_API_URL')}/login`}
          onClick={signIn}
          fontSize="15px"
        >
          Sign In/Up
        </Button>
      )}
    </Layout.Group>
  );

  return (
    <ModalDialog
      size="lg"
      css={{
        'abyss-modal-base-content-container': {
          height: '222px',
          width: '700px',
        },
        'abyss-modal-base-footer': {
          display: 'flex',
          flexDirection: 'row-reverse !important',
        },
      }}
      header="Request a meeting with an API consultant"
      isOpen={isSubscribeModalOpen}
      onClose={() => {
        return onModalClose();
      }}
      footer={footer}
    >
      <p style={{ fontSize: '15px' }}>
        To request an API subscription, sign into your account now. If you do
        not have an account, you can create one.
      </p>
    </ModalDialog>
  );
};

SubscribeModal.propTypes = {
  setIsSubscribeModalOpen: PropTypes.func.isRequired,
  isSubscribeModalOpen: PropTypes.bool.isRequired,
};
